// src/pages/Signesabreviations.js
import React, { useState } from "react";
import css from './Signesabreviations.module.css';

function Signesabreviations() {
  const [active, setActive] = useState("signes");

  const handleNavClick = (id) => {
    setActive(id);
    const el = document.getElementById(id);
    if (!el) return;
    const y = el.getBoundingClientRect().top + window.scrollY - 120; // ajuste si besoin
    window.scrollTo({ top: y, behavior: "smooth" });
  };

  return (
    <main className={css.page}>
      <div className={css.layout}>
        {/* HERO */}
        <header className={css.hero}>
          <div className={css.heroKicker}>Partie introductive</div>
          <h1 className={css.heroTitle}>Guide du dictionnaire</h1>
          <p className={css.heroSub}>
            Conventions, signes, abréviations, méthode de recherche et règles
            d’orthographe du kinyarwanda.
          </p>
        </header>

        {/* SOUS-NAV (tabs sous le hero) */}
        <nav className={css.subnav} aria-label="Sommaire du guide">
          <ul>
            <li>
              <button
                type="button"
                className={`${css.tab} ${active === "signes" ? css.tabActive : ""}`}
                onClick={() => handleNavClick("signes")}
              >
                I. Signes &amp; abréviations
              </button>
            </li>
            <li>
              <button
                type="button"
                className={`${css.tab} ${active === "trouver" ? css.tabActive : ""}`}
                onClick={() => handleNavClick("trouver")}
              >
                II. 1 Trouver un mot
              </button>
            </li>
            <li>
              <button
                type="button"
                className={`${css.tab} ${active === "lire" ? css.tabActive : ""}`}
                onClick={() => handleNavClick("lire")}
              >
                II. 2 Comment lire un article
              </button>
            </li>
            <li>
              <button
                type="button"
                className={`${css.tab} ${active === "ortho" ? css.tabActive : ""}`}
                onClick={() => handleNavClick("ortho")}
              >
                III. Orthographe
              </button>
            </li>
          </ul>
        </nav>

        {/* CONTENU */}
        <div className={css.content}>
          {/* I. SIGNES & ABRÉVIATIONS */}
          <section id="signes" className={css.section}>
            <h2 className={css.sectionTitle}>I. Signes &amp; abréviations</h2>

            <div className={css.gridColumn}>
                {/* Signes */}
                <div className={css.card}>
                  <h3 className={css.cardTitle}>Signes</h3>
                  <div className={css.definitionList}>
                    <div className={css.definitionRow}>
                      <div className={css.itemCode}>signe de renvoi</div>
                      <div className={css.itemDescription}></div>
                    </div>
                    <div className={css.definitionRow}>
                      <div className={css.itemCode}>[…]</div>
                      <div className={css.itemDescription}>notation phonétique</div>
                    </div>
                    <div className={css.definitionRow}>
                      <div className={css.itemCode}>/…/</div>
                      <div className={css.itemDescription}>notation phonologique</div>
                    </div>
                    <div className={css.definitionRow}>
                      <div className={css.itemCode}>|…|</div>
                      <div className={css.itemDescription}>notation morphologique</div>
                    </div>
                    <div className={css.definitionRow}>
                      <div className={css.itemCode}>|+ …|</div>
                      <div className={css.itemDescription}>
                        indication de début de la racine à l’intérieur d’une
                        analyse morphologique
                      </div>
                    </div>
                    <div className={css.definitionRow}>
                      <div className={css.itemCode}>-ø-</div>
                      <div className={css.itemDescription}>
                        absence formelle de morphème (expression du présent
                        indicatif)
                      </div>
                    </div>
                    <div className={css.definitionRow}>
                      <div className={css.itemCode}>1</div>
                      <div className={css.itemDescription}>
                        marque de classe : la classe donnée est celle de l’accord
                        et non celle du classificateur du mot. Lorsqu’il y a
                        plusieurs chiffres (par ex. : 3-4-6), cela signifie que
                        l’entrée, selon le contexte, est susceptible d’être
                        accordée dans chacune des classes mentionnées.
                      </div>
                    </div>
                    <div className={css.definitionRow}>
                      <div className={css.itemCode}></div>
                      <div className={css.itemDescription}>numérotation d’une définition</div>
                    </div>
                    <div className={css.definitionRow}>
                      <div className={css.itemCode}>♦</div>
                      <div className={css.itemDescription}>symbole introducteur de définition ou de locution</div>
                    </div>
                    <div className={css.definitionRow}>
                      <div className={css.itemCode}>◊</div>
                      <div className={css.itemDescription}>symbole introducteur d’exemple</div>
                    </div>
                    <div className={css.definitionRow}>
                      <div className={css.itemCode}>♥</div>
                      <div className={css.itemDescription}>symbole introducteur de variante</div>
                    </div>
                    <div className={css.definitionRow}>
                      <div className={css.itemCode}></div>
                      <div className={css.itemDescription}>
                        symbole introducteur de synonyme, d’équivalent standard,
                        ou d’évitement
                      </div>
                    </div>
                    <div className={css.definitionRow}>
                      <div className={css.itemCode}></div>
                      <div className={css.itemDescription}>symbole introducteur de dérivation</div>
                    </div>
                    <div className={css.definitionRow}>
                      <div className={css.itemCode}></div>
                      <div className={css.itemDescription}>symbole introducteur de contraire</div>
                    </div>
                    <div className={css.definitionRow}>
                      <div className={css.itemCode}></div>
                      <div className={css.itemDescription}>
                        symbole introducteur d’une notice encyclopédique
                      </div>
                    </div>
                  </div>
                </div>

                {/* Sources / auteurs */}
                <div className={css.card}>
                  <h3 className={css.cardTitle}>Sources / Auteurs</h3>
                  <ul className={css.sourceList}>
                    <li>(AM) Agnès Murebwayire</li>
                    <li>(BD) Birekeraho Damase</li>
                    <li>(C. et al.) Coupez et alii</li>
                    <li>(C.B.) Crépeau et Bizimana</li>
                    <li>(DK) Dismas Kaboyi</li>
                    <li>(FK) François Kanyamihanda</li>
                    <li>(PM) Pélagie Murebwayire</li>
                    <li>(RS) Rugigana Stanislas</li>
                    <li>(français, emprunt)</li>
                    <li>(urukonjo)</li>
                  </ul>
                </div>

              {/* Abréviations grammaticales */}
              <div className={css.card}>
                <h3 className={css.cardTitle}>Abréviations grammaticales</h3>
                <div className={css.abbreviationsGrid}>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>act</div>
                    <div className={css.itemDescription}>morphème d’actualisation</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>adj.</div>
                    <div className={css.itemDescription}>adjectif</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>adv.</div>
                    <div className={css.itemDescription}>adverbe</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Anc.</div>
                    <div className={css.itemDescription}>ancienne utilisation du mot</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>asp</div>
                    <div className={css.itemDescription}>aspect</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>aug</div>
                    <div className={css.itemDescription}>augment</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Cl.</div>
                    <div className={css.itemDescription}>classificateur</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>cont</div>
                    <div className={css.itemDescription}>continuatif</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Contr.</div>
                    <div className={css.itemDescription}>contraire</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>cplt</div>
                    <div className={css.itemDescription}>complément</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Cult.</div>
                    <div className={css.itemDescription}>notice culturelle</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Déict.</div>
                    <div className={css.itemDescription}>déictique</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Dev.</div>
                    <div className={css.itemDescription}>devinette</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Évit.</div>
                    <div className={css.itemDescription}>évitement</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Fam.</div>
                    <div className={css.itemDescription}>familier</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Hist.</div>
                    <div className={css.itemDescription}>notice historique</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Inc.</div>
                    <div className={css.itemDescription}>inchoatif</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>intr.</div>
                    <div className={css.itemDescription}>intransitif</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>invar.</div>
                    <div className={css.itemDescription}>invariable</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Lég.</div>
                    <div className={css.itemDescription}>
                      légende : considérer ces récits comme des légendes et non
                      des vérités historiques établies, et vérifier les noms et
                      les dates cités.
                    </div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Litt.</div>
                    <div className={css.itemDescription}>littéral</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Loc.</div>
                    <div className={css.itemDescription}>locution</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Locatif</div>
                    <div className={css.itemDescription}></div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>n.</div>
                    <div className={css.itemDescription}>nom</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>nég</div>
                    <div className={css.itemDescription}>négateur</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Néol.</div>
                    <div className={css.itemDescription}>néologisme</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Par ext.</div>
                    <div className={css.itemDescription}>par extension</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>pers.</div>
                    <div className={css.itemDescription}>personne</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>pl.</div>
                    <div className={css.itemDescription}>pluriel</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Plur.</div>
                    <div className={css.itemDescription}>
                      pluriel spécialisé avec un sens précis différent de celui
                      du singulier
                    </div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Poét.</div>
                    <div className={css.itemDescription}>poétique</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>pot</div>
                    <div className={css.itemDescription}>potentiel</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>pr.</div>
                    <div className={css.itemDescription}>pronom</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>pr.rel.</div>
                    <div className={css.itemDescription}>pronom relatif</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Prov.</div>
                    <div className={css.itemDescription}>proverbe</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Q.</div>
                    <div className={css.itemDescription}>question</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>R.</div>
                    <div className={css.itemDescription}>réponse</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Scol.</div>
                    <div className={css.itemDescription}>scolaire (jargon d’étudiants)</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>sg.</div>
                    <div className={css.itemDescription}>singulier</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>smlf</div>
                    <div className={css.itemDescription}>sémelfactif</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Strd.</div>
                    <div className={css.itemDescription}>standard (équivalent)</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>subs</div>
                    <div className={css.itemDescription}>subsécutif</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Syn.</div>
                    <div className={css.itemDescription}>synonyme</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>Temporel</div>
                    <div className={css.itemDescription}></div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>tps</div>
                    <div className={css.itemDescription}>temps</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>tr.</div>
                    <div className={css.itemDescription}>transitif</div>
                  </div>
                  <div className={css.definitionRow}>
                    <div className={css.itemCode}>v.</div>
                    <div className={css.itemDescription}>verbe</div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* II. TROUVER UN MOT & LIRE UN ARTICLE */}
          <section id="trouver" className={css.section}>
            <h2 className={css.sectionTitle}>II. Trouver un mot et lire un article</h2>

            <div className={css.gridColumn}>
              {/* II.1 Trouver un mot */}
              <article className={css.card}>
                <h3 className={css.cardTitle}>II. 1 Trouver un mot</h3>

                <p>
                  Il faut se référer à sa forme la plus originelle, avant
                  d’entrer en phrase :
                </p>

                <p>
                  S’il s’agit d’un substantif, il faut chercher sa forme du
                  singulier avec son augment. L’augment est une voyelle qui
                  débute le mot, elle est semblable, dans la plupart des cas, à
                  celle du classificateur. Les mots désignant les groupes ou les
                  clans peuvent être trouvés à partir de leur forme du pluriel.
                </p>

                <p>
                  S’il s’agit d’un pronom, il faut chercher sa forme telle que
                  vous la trouvez dans le contexte.
                </p>

                <p>
                  S’il s’agit d’un verbe, il faudra impérativement se référer à
                  la forme de l’infinitif.
                </p>

                <p>
                  S’il s’agit d’un adjectif ou d’un verbe défectif, il faut
                  chercher sa forme telle que vous la trouvez dans le contexte
                  ou se référer à son radical (son thème).
                </p>

                <p>
                  Les mots invariables comme les noms propres ou les adverbes
                  seront trouvés tels quels dans le dictionnaire.
                </p>

                <div className="guide-callout">
                  Ne jamais perdre de vue qu’un mot peut varier de
                  classificateur soit parce qu’il est au pluriel, soit parce
                  qu’il se trouve dans une classe qualifiante (7, 8, 9, 10).
                  S’il s’agit d’un substantif, il faut le chercher dans sa
                  classe originelle ; s’il s’agit d’un adjectif, il faut
                  chercher son thème ou chercher la forme telle qu’elle se
                  présente. Ainsi, pour les mots <i>ikigabo</i>,{" "}
                  <i>urugabo</i>, <i>ibigabo</i>, <i>akagabo</i>,{" "}
                  <i>utugabo</i>, il faudra trouver la définition sous l’entrée{" "}
                  <i>Umugabo | abagabo</i>.
                </div>
              </article>

              {/* II.2 Comment lire un article */}
              <article id="lire" className={css.card}>
                <h3 className={css.cardTitle}>II. 2 Comment lire un article</h3>

                <p>
                  L’entrée en petites lettres capitales est présentée sous sa
                  forme de singulier suivie, éventuellement après une barre
                  verticale, de son pluriel. Celles qui sont transcrites en
                  rouge et noir : la partie écrite en rouge indique les
                  préfixes du mot (augment + classificateur), la partie en noir
                  indique le thème (racine + suffixes) du mot. La première
                  lettre de la racine affectée par les règles de contact ne
                  correspond pas toujours à celle qui commence la racine. Il ne
                  s’agit donc pas d’une analyse morphologique à proprement
                  parler, mais d’une indication du début de la racine.
                </p>

                <p>
                  L’entrée est suivie, entre deux barres obliques (slashes),
                  d’une notation phonologique qui indique la tonalité et la
                  longueur vocalique. Après le dernier slash, le chiffre indique
                  la classe. La classe indiquée est la classe d’accord, par
                  exemple pour les noms de lieux (classe 11), de rivières
                  (classe 6) ou de personnes (classe 1) ; ce n’est pas
                  nécessairement la classe formelle indiquée par le
                  classificateur du mot. Elle comprend pour nous le singulier et
                  le pluriel.
                </p>

                <p>
                  Suivent alors les spécifications grammaticales dont les
                  abréviations figurent dans le tableau des signes et des
                  sigles. Particulièrement pour le verbe, la terminaison
                  perfective est indiquée, car elle n’est pas toujours aisée à
                  trouver pour ceux qui ne parlent pas kinyarwanda.
                </p>

                <p>L’article est structuré en quatre parties :</p>

                <h4 className={css.cardTitle}>Adressage</h4>
                <p>
                  L’adressage est constitué de l’entrée en petites capitales
                  suivie de sa notation phonologique et des spécifications
                  grammaticales.
                </p>

                <h4 className={css.cardTitle}>Définitions et exemples</h4>
                <p>
                  Les définitions sont numérotées lorsqu’elles sont plusieurs
                  dans un article. Elles sont introduites par un losange noir
                  suivi éventuellement d’une indication du niveau de langue
                  (♦Fam., ♦Péj., ♦Vulg., ♦Anc., ♦Évit., etc.). Le losange noir
                  introduit les locutions (♦Loc.) qui sont transcrites en rouge.
                </p>

                <p>
                  Le losange clair introduit un exemple : la plupart des
                  exemples sont tirés des textes sur internet ; ils peuvent
                  parfois être aussi des proverbes ou des devinettes (◊ Prov.,
                  ◊ Dev., etc.) dont la source est indiquée entre parenthèses,
                  juste avant la traduction. Les exemples qui ne sont pas
                  sourcés ont été créés par le rédacteur.
                </p>

                <h4 className={css.cardTitle}>Équivalents, contraires et dérivés</h4>
                <p>
                  Dans l’article peuvent figurer également les variantes
                  (♥Var.), les synonymes (Syn.), l’équivalent du mot en
                  kinyarwanda standard s’il s’agit du langage urukonjo (Strd.),
                  les mots dérivés (Dér.), les antonymes (■Contr.).
                </p>

                <h4 className={css.cardTitle}>Notices encyclopédiques</h4>
                <p>
                  Il s’agit de notices historiques (Hist.), légendaires (Lég.),
                  culturelles (Cult.). Cette partie n’est présente que pour les
                  articles qui nécessitent ce traitement.
                </p>
              </article>
            </div>
          </section>

          {/* III. ORTHOGRAPHE */}
          <section id="ortho" className={css.section}>
            <h2 className={css.sectionTitle}>III. L’orthographe du kinyarwanda</h2>

            <div className={css.orthoCard}>
              <p>
                La rédaction de ce dictionnaire était déjà très avancée lorsque
                la loi sur l’orthographe du kinyarwanda a été publiée le
                13/10/2014. Nous avons adopté l’orthographe du 2 juillet 1985
                avec quelques modifications. Il est vrai que, de notre côté,
                nous avions commencé à réfléchir sur ce texte de loi et sur des
                aménagements à y apporter.
              </p>

              <p>
                Mais dans l’ensemble, pour permettre la recherche des mots
                écrits sous l’ancienne orthographe et sous la nouvelle, nous
                conservons les deux graphies sous deux entrées différentes,
                l’une faisant référence à l’autre. Il y a juste quelques
                différences avec l’orthographe actuelle et l’ancienne, qui ne
                nuisent pas à la lecture :
              </p>

              <div className={css.orthoGrid}>
                <div className={css.orthoItem}>
                  <h3>Particules « ho, yo, mo, mwo, ko »</h3>
                  <p>
                    Les particules « ho », « yo », « mo », « mwo » et « ko »
                    sont notées séparément, notamment quand elles sont précédées
                    d’un verbe : <i>ngiye yo</i>, « j’y vais » ;{" "}
                    <i>yamwirutse ho</i>, « il a couru après lui » ;{" "}
                    <i>ndakeka ko atari byo</i>, « je pense que ce n’est pas
                    vrai ».
                  </p>
                </div>

                <div className={css.orthoItem}>
                  <h3>Particule négative « nta »</h3>
                  <p>
                    La particule négative « nta » est notée séparément du nom,
                    du pronom ou du verbe conjugué qui la suit :{" "}
                    <i>nta we nabonye</i>, « je ne l’ai pas vu » ;{" "}
                    <i>nta baragenda</i>, « personne n’est encore parti ».
                  </p>
                </div>

                <div className={css.orthoItem}>
                  <h3>Présentatif « ni »</h3>
                  <p>
                    Le présentatif « ni » thétique, hypothétique ou impératif
                    est toujours noté séparément du nom ou du verbe conjugué qui
                    le suit : <i>ni byo</i>, « c’est vrai » ;{" "}
                    <i>ni ujya i Kigali</i>, « si tu vas à Kigali » ;{" "}
                    <i>ni mugende</i>, « partez ».
                  </p>
                </div>

                <div className={css.orthoItem}>
                  <h3>Augment |u-| des noms de lieu</h3>
                  <p>
                    L’augment |u-| qui précède un nom de lieu est toujours lié
                    au nom qui le suit : <i>Urwanda</i>, <i>Ubusanza</i>,{" "}
                    <i>Ubugoyi</i>.
                  </p>
                </div>

                <div className={css.orthoItem}>
                  <h3>Notation du ton</h3>
                  <p>
                    Le ton haut est noté par l’accent aigu dans l’orthographe
                    phonologique : <i>/umuréera/</i>. Il ne sera utilisé que
                    pour la notation phonologique des entrées et l’analyse
                    morphologique.
                  </p>
                </div>

                <div className={css.orthoItem}>
                  <h3>Orthographe usuelle &amp; prononciation</h3>
                  <p>
                    Pour faciliter la consultation, nous avons choisi
                    expressément l’orthographe usuelle ; la notation
                    phonologique ou scientifique, suivant l’entrée, n’intervient
                    que pour indiquer la valeur tonale ou la longueur vocalique
                    au niveau de la prononciation.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
}

export default Signesabreviations;
